exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  max-width: 400px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/add-gym-to-class-templates/add-gym-to-class-templates.component.scss
// module id = ../../../../../src/app/components/add-gym-to-class-templates/add-gym-to-class-templates.component.scss
// module chunks = main